import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { buildingApi } from '../api/buildingApi'
import type { Building } from '../types/building'

export function useGetBuildings(enabled = true) {
  return useQuery({
    queryKey: ['buildings'],
    queryFn: () => buildingApi.getBuildings(),
    retry: false,
    refetchOnWindowFocus: false,
    enabled,
  })
}

export function useGetBuilding(id: string) {
  return useQuery({
    queryKey: ['building', id],
    queryFn: () => buildingApi.getBuilding(id),
    enabled: !!id,
    retry: false,
    refetchOnWindowFocus: false,
  })
}

export function useCreateBuilding() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: buildingApi.createBuilding,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['buildings'] })
    },
  })
}

export function useUpdateBuilding() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: Partial<Building> }) =>
      buildingApi.updateBuilding(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['buildings'] })
      queryClient.invalidateQueries({ queryKey: ['building'] })
    },
  })
}

export function useDeleteBuilding() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => buildingApi.deleteBuilding(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['buildings'] })
    },
  })
}
